import { googleAssetFieldType, googleCallToActionEnums } from '../../../../../../../constants/ads'

import {
  CLICK_THROUGH_LINK,
  ASSET_TYPE,
  LANDSCAPE_IMAGE,
  LANDSCAPE_LOGO,
  NAME,
  PORTRAIT_IMAGE,
  SQUARE_IMAGE,
  SQUARE_LOGO,
  VIDEO_ADS_OPTION,
  VIDEO_ADS_ENTER,
  FILE_URL,
  ASSET_GROUP_TYPE,
  BUSINESS_NAME
} from '../../../../fields'
import { formatImageListToAssets, formatTextValuesToAssetsCreation } from '../../../formatters'
import { CALL_TO_ACTION } from '../../../../../../Facebook/AdForms/fields'

export const transformValuesToAssetsCreation = (values, adAccountId) => {
  const assets = []

  // list of AssetFieldType for corresponding field_type
  // headlines HEADLINE 2
  // descriptions DESCRIPTION 3
  // long headline LONG_HEADLINE 17
  // business name BUSINESS_NAME 18
  // landscape image MARKETING_IMAGE 5
  // square image SQUARE_MARKETING_IMAGE 19
  // portrait image PORTRAIT_MARKETING_IMAGE 20
  // square logo LOGO 21
  // landscape logo LANDSCAPE_LOGO 22
  // youtube links YOUTUBE_VIDEO 7
  // call to action CALL_TO_ACTION_SELECTION 25

  const textAssets = formatTextValuesToAssetsCreation({
    values,
    adAccountId,
    allowIncludeYoutubeLink: values[VIDEO_ADS_OPTION] === VIDEO_ADS_ENTER
  })
  assets.push(...textAssets)

  assets.push({
    account: adAccountId,
    text_asset: { text: values[BUSINESS_NAME] },
    [ASSET_GROUP_TYPE]: googleAssetFieldType.BUSINESS_NAME
  })
  assets.push({
    account: adAccountId,
    call_to_action_asset: { call_to_action: googleCallToActionEnums[values[CALL_TO_ACTION]] },
    [ASSET_GROUP_TYPE]: googleAssetFieldType.CALL_TO_ACTION_SELECTION
  })

  return assets
}

export const transformValuesToBE = (values, assetsData, submittedAssetsList) => {
  const assets = []

  assetsData.operations.forEach((asset, index) => {
    const assetTypeLabel = submittedAssetsList[index][ASSET_GROUP_TYPE]

    assets.push({
      asset: asset.resource_name,
      // asset type for AssetsGroup should be selected from submittedAssetsList as GOOGLE replace the name to it`s
      // own after assets creation, so population should be taken from the payload data(submittedAssetsList) not the
      // response data(assetsData)
      [ASSET_TYPE]: assetTypeLabel,
      // hardcode status for 2 - ENABLED(AssetLinkStatus)
      status: 2
    })
  })

  // PORTRAIT_IMAGE and LANDSCAPE_LOGO are not required fields, so we don't include them to payload if they are not loaded
  const hasPortraitImage = values[PORTRAIT_IMAGE].length && values[PORTRAIT_IMAGE][0][FILE_URL]
  const hasLandscapeImage = values[LANDSCAPE_LOGO].length && values[LANDSCAPE_LOGO][0][FILE_URL]

  assets.push(...formatImageListToAssets(values[LANDSCAPE_IMAGE], googleAssetFieldType.MARKETING_IMAGE))
  assets.push(...formatImageListToAssets(values[SQUARE_IMAGE], googleAssetFieldType.SQUARE_MARKETING_IMAGE))
  hasPortraitImage &&
    assets.push(...formatImageListToAssets(values[PORTRAIT_IMAGE], googleAssetFieldType.PORTRAIT_MARKETING_IMAGE))
  assets.push(...formatImageListToAssets(values[SQUARE_LOGO], googleAssetFieldType.LOGO))
  hasLandscapeImage &&
    assets.push(...formatImageListToAssets(values[LANDSCAPE_LOGO], googleAssetFieldType.LANDSCAPE_LOGO))

  return {
    [NAME]: values[NAME],
    // in our create form we have just 1 link, but link should be an array:
    [CLICK_THROUGH_LINK]: [values[CLICK_THROUGH_LINK]],
    assets
  }
}
